var css = {"closeIcon":"Toast-module_closeIcon__IuLEd","mainIcon":"Toast-module_mainIcon__nCkuR","wrapper":"Toast-module_wrapper__0Tvq2","slideInDown":"Toast-module_slideInDown__jWHtp"};

export { css as default };
